module.exports = __webpack_public_path__ + "static/media/spinner-light_Visual.510d4583.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spinner-light_Visual.gif
// module id = 466
// module chunks = 0 1 2 3 4 5 6 7 8 9 10